module.exports = __webpack_public_path__ + "img/53.67dd47c2.jpg";